import { observable, action } from 'mobx';
import { Properties } from 'api';

class PropertiesStore {
  @observable properties = [];

  @observable fetchState;

  anketId;

  @action.bound
  async getProperties(anketId) {
    if (this.anketId === anketId) {
      return;
    }

    this.fetchState = 'pending';

    try {
      const response = await Properties.getProperties(anketId);
      this.properties = response.data;
      this.fetchState = 'fulfilled';
      this.anketId = anketId;
    } catch (e) {
      this.fetchState = 'rejected';
    }
  }
}

const propertiesStore = new PropertiesStore();

export default propertiesStore;
